<template>
  <full-page class="magic-ui-fullpage" ref="fullPageRef" :options="{ onLeave, afterLoad }">
    <magic-ui-component
      class="section"
      v-for="(item, index) in config.items"
      :key="item.id"
      :class="{'fp-auto-height': item.style.height !=='100%'}"
      :style="{'--height': item.style.height}"
      :config="computedContainer(item, index)"
    ></magic-ui-component>
  </full-page>
</template>

<script lang="ts" setup>
import { reactive, watch, ref, onMounted, onUnmounted } from 'vue';
import { MComponent } from '@tmagic/schema';
import fullPage from './fullPage.vue';
import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';
import magicUiComponent from '../../../Component.vue';
import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & typeof initValue;
}>();
const app = useApp(props); // 组件注册在app上，不可删除
const node = app?.page?.getNode(props.config.id!);
// 组件逻辑写在此行后面
const selectPath = ref();
const fullPageRef = ref();
const originalOverflow = ref();
onMounted(() => {
  originalOverflow.value = getComputedStyle(document.querySelector('#app')).overflow;
  document.querySelector('#app').style['overflow'] = 'hidden';
})

onUnmounted (() => {
   document.querySelector('#app').style['overflow'] = originalOverflow.value;
})
if (app?.mode === 'playground') {
  app?.on('editor:select', (info, path) => {
    selectPath.value = path;
  });

}
else {
    props.config.items.forEach(item => { 
    item.display = true;
    item.style = app.transformStyle(item.style);
  });
}
const computedContainer = (item: any, index: number) => {
  if (window.location.pathname.indexOf('playground') === -1) {
    return item;
  }
  const seletNode = selectPath?.value?.find((node: MNode) =>
    props.config.items.find((item) => item.id === node.id)
  );

  item.display =
    (index === props.config.currentPage && !seletNode) ||
    seletNode?.id == item.id;
  return item;
};


const onLeave = (origin, destination, direction, trigger) => {
  app?.emit('onLeave', node);
};

const moveTo = (pageIndex: number) => {
  fullPageRef.value.api.moveTo(pageIndex);
};
const moveSectionUp = () => {
  fullPageRef.value.api.moveSectionUp();
};
const moveSectionDown = () => {
  fullPageRef.value.api.moveSectionDown();
};

const afterLoad = () => {
  app?.emit('afterLoad', node);
}
const getActiveSection = () => {
  return fullPageRef.value.api.getActiveSection().index;
};
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  moveSectionUp,
  moveSectionDown,
  moveTo,
  getActiveSection,
});

defineExpose(exportInterface);
</script>
<style lang="scss" scoped>
.fp-auto-height.fp-section {
  height: var(--height) !important;
}
</style>
<style lang="scss">
</style>
